import { render, staticRenderFns } from "./fdtmArticleContent.vue?vue&type=template&id=1f0b0050&scoped=true&"
import script from "./fdtmArticleContent.vue?vue&type=script&lang=js&"
export * from "./fdtmArticleContent.vue?vue&type=script&lang=js&"
import style0 from "./fdtmArticleContent.vue?vue&type=style&index=0&id=1f0b0050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b0050",
  null
  
)

component.options.__file = "fdtmArticleContent.vue"
export default component.exports